module.exports = __webpack_public_path__ + "img/recipes.5a3aee27.svg";